<style scoped lang="less">
    @import "assets/vars.less";

    .albums {
        &_page {
            position: relative;
        }
        &_info {
            padding: 15px;
            > h2 {
                text-align: center;
                font-weight: 400;
                letter-spacing: 2px;
                color: @dark;
            }
        }
        &_list {
            padding: 10px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: flex-start;
        }
        &_item {
            position: relative;
            width: 25%;
            padding: 5px;
            img {
                width: 100%;
                opacity: .9;
                filter: grayscale(20%);
                transition: all .3s;
            }
            &:hover {
                img {
                    opacity: 1;
                    filter: grayscale(0%);
                }
            }

            &_link {
                position: absolute;
                width: calc(~"100% - 10px");
                left: 0;
                bottom: 4px;
                margin: 5px;
                padding: 15px;
                color: @white;
                background: fade(@dark, 60%);
                text-decoration: none;
                z-index: 1;
            }

            @media (max-width: 1100px) {
                width: calc(~"100% / 3");
            }

            @media (max-width: 900px) {
                width: calc(~"100% / 2");
            }

            @media (max-width: 700px) {
                width: 100%;
            }
        }
    }

</style>

<template>
    <div>
        <transition name="fade">
            <div class="albums_page">
                <transition name="fade">
                    <div v-if="loaded" class="albums_data">
                        <div class="albums_info">
                            <h2>Портфолио</h2>
                            <div class="monogram"></div>
                        </div>

                        <div class="albums_list">
                            <div class="albums_item" v-for="album in albumsData.albums">
                                <router-link :to="'/gallery&id=' + album.link">
                                    <img :src="album.image" alt="">
                                    <div class="albums_item_link">{{album.title}}</div>
                                </router-link>
                            </div>
                        </div>

                    </div>
                </transition>
                <transition name="fade">
                    <div v-if="!loaded" class="loader">
                        <img v-if="!error" src="./assets/waiting.svg" alt="">
                        <p class="error" v-if="error">Произошла ошибка. Попробуйте позже.</p>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'albums',
        components: {},
        data () {
            return {
                error: false,
                loaded: false,
                albumsData: {},
            };
        },
        methods: {
            getAlbums () {
                axios
                    .get('https://api.paparazzi48.ru/albums')
                    .then(response => {
                        if (response.data) {
                            this.loaded = true;
                            this.albumsData = response.data;
                        }
                    })
                    .catch(() => {
                        this.error = true;
                    });
            },
        },
        mounted () {
            if (!this.loaded) {
                this.getAlbums();

            }
        },
    };
</script>